import styles from "./index.module.scss"

export const guideTitle = "How to read the Monitoring temperature graph"

export const GuideChart = ({ variant = "overview" }: { variant?: "overview" | "heating" | "cooling" | "issue" }) => {
  const overview = variant === "overview"
  const current = overview
    ? "36,84 72,90 110,93 126,89 148,108 170,130 185,135 210,110 240,80 265,61 294,52 310,50 340,97 370,134 400,137 420,132 450,105"
    : variant === "heating"
      ? "36,169 100,154 170,137 240,123 310,121 380,121 450,121"
      : variant === "issue"
        ? "36,49 100,49 170,46 240,48 310,45 380,45 450,44"
        : "36,73 100,88 170,106 240,121 310,121 380,121 450,121"
  return (
    <figure className={styles.chart}>
      <svg viewBox="0 0 480 245" role="img" aria-label={`${variant} temperature example in degrees Fahrenheit`}>
        {[25, 85, 145, 205].map((y, index) => (
          <g key={y}>
            <path d={`M36 ${y}H450`} className={styles.grid} />
            <text x="0" y={y + 4}>
              {80 - index * 5}°F
            </text>
          </g>
        ))}
        {[36, 140, 192, 244, 313, 382, 450].map((x, index) => (
          <g key={x}>
            <path d={`M${x} 10V218`} className={styles.grid} strokeDasharray="3 4" />
            <text x={x} y="242">
              {overview
                ? [0, 6, 9, 12, 16, 20, 24][index]
                : [0, 3, 6].includes(index)
                  ? (variant === "heating" ? 6 : 16) + index
                  : ""}
            </text>
          </g>
        ))}
        <path d={`M36 ${variant === "heating" ? 121 : 193}H450`} stroke="#ef4444" fill="none" strokeWidth="2" />
        {!overview && (
          <path d={`M36 ${variant === "heating" ? 36 : 121}H450`} stroke="#2463eb" fill="none" strokeWidth="2" />
        )}
        <polyline
          points={
            overview ? "36,83 122,83 140,137 174,137 192,55 297,55 313,137 399,137 416,83 450,83" : "36,121 450,121"
          }
          stroke="#22c55e"
          fill="none"
          strokeWidth="3"
        />
        <polyline points={current} stroke="#43e0f8" fill="none" strokeWidth="3" strokeLinejoin="round" />
        <rect x="36" y="219" width="414" height="14" rx="3" className={styles.schedule} />
        {overview ? (
          ["Sleep", "Wake", "Away", "Home"].map((label, i) => (
            <text key={label} x={70 + i * 104} y="229">
              {label}
            </text>
          ))
        ) : (
          <text x="225" y="229">
            {variant === "heating" ? "Wake" : "Home"}
          </text>
        )}
        {overview && (
          <>
            <text x="195" y="16">
              Set
            </text>
            <path d="M205 20L242 55" className={styles.grid} />
            <text x="392" y="48">
              Current
            </text>
            <path d="M393 53L382 135" className={styles.grid} />
            <text x="210" y="211">
              Heat to Temp
            </text>
          </>
        )}
      </svg>
      <figcaption className={styles.legend}>
        {["Current temperature", "Set temperature", "Cool to Temp", "Heat to Temp"].map((label, i) => (
          <span key={label}>
            <i className={styles.swatch} style={{ background: ["#43e0f8", "#22c55e", "#2463eb", "#ef4444"][i] }} />
            {label}
          </span>
        ))}
      </figcaption>
    </figure>
  )
}
